import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';

const MIN_LEADING_VALUE = 10;
const MAX_LEADING_VALUE = 500;

interface ItemBaseLineHeightOptionProps {
  leading: number;
  addDelayToOnChange?: boolean;
  onUpdateLeadingValue(leading: number, undoable?: boolean): void;
}

export function ItemBaseLineHeightOption({...props}: ItemBaseLineHeightOptionProps): ReactElement<any> {
  const updateLeadingValue = (leading: number, undoable = true): void => {
    props.onUpdateLeadingValue(leading, undoable);
  };

  const onChangeHandler = (updatedValue: number): void => {
    updateLeadingValue(updatedValue, false);
  };

  const onChangeEnded = (updatedValue: number): void => {
    updateLeadingValue(updatedValue);
  };

  return (
    <ContextualMenuSliderOptions
      id="text-line-height-option"
      value={props.leading}
      label={window.i18next.t('pmwjs_line_height')}
      range={{
        min: MIN_LEADING_VALUE,
        max: MAX_LEADING_VALUE,
      }}
      transformDisplay={{
        min: MIN_LEADING_VALUE,
        max: MAX_LEADING_VALUE,
      }}
      addDelayToOnChange={props.addDelayToOnChange}
      onChange={onChangeHandler}
      onChangeEnded={onChangeEnded}
    />
  );
}
